import React, { useContext, useState } from "react";

import { AppSettings } from "../../config/app-settings";

import PageFilter from "../../components/PageFilter";
import toastMessage from "../../components/ToastMessage";
import DynamicCard from "../../components/DynamicCard";

import IlceGeneliPartilerinOyDegisimi from "./IlceGeneliPartilerinOyDegisimi";
import SiyasiKimlikDagilimi from "./SiyasiKimlikDagilimi";
import GenelSiyasiAnketSonuclari from "./GenelSiyasiAnketSonuclari";
import MahalleGeneliPartilerinOyDegisimi from "./MahalleGeneliPartilerinOyDegisimi";
import IlceGeneliPartilerinOyDegisimiBar from "./IlceGeneliPartilerinOyDegisimiBar";

export default function SiyasiAnaliz() {
  const context = useContext(AppSettings);

  // Get Data
  const [selectedSection, setSelectedSection] = useState(null);
  const [city, setCity] = useState(null);
  const [district, setDistrict] = useState(null);
  const [allNeighborhood, setAllNeighborhood] = useState(null);

  function getReport(
    name,
    city,
    district,
    neighborhood,
    street,
    allNeighborhood
  ) {
    if (!city && !district) {
      toastMessage(context?.t?.il_ve_ilce_filtrelemeniz_gerekiyor, "error");
      return;
    }

    setSelectedSection(name);
    setCity(city?.label || null);
    setDistrict(district?.label || null);

    if (name === "neighbourhood") {
      setAllNeighborhood(allNeighborhood.filter((item) => item.value));
    }
  }

  return (
    <div className="row g-4 mb-5 pb-5">
      <PageFilter
        neighbourhoodShow={false}
        street={false}
        report={true}
        siyasiAnaliz={true}
        getReport={getReport}
      />

      {selectedSection && (
        <div className="col-12">
          <div className="row g-3">
            {selectedSection === "district" ? (
              <div className="col-12">
                <div className="row g-3">
                  <div className="col-12">
                    <h4>{context?.t?.ilce_analizi}</h4>

                    <ol className="d-inline-flex breadcrumb mb-0">
                      <li className="breadcrumb-item">{city}</li>
                      <li className="breadcrumb-item">{district}</li>
                    </ol>
                  </div>

                  <div className="col-12">
                    <IlceGeneliPartilerinOyDegisimi
                      city={city}
                      district={district}
                      title="İlçe Geneli Partilerin Oy Değişimi"
                    />
                  </div>

                  <div className="col-12 col-lg-6">
                    <IlceGeneliPartilerinOyDegisimiBar
                      title="Alınan Göçün Siyasi Duruma Etkisi"
                      city={city}
                      district={district}
                      type={"alinan-verilen-goc-siyaset-etkisi"}
                      filter={{
                        key: "ALT-KATEGORI-2",
                        value: "ALINAN GÖÇÜN SİYASETE ETKİSİ (BİREY BAZLI)",
                        operator: "=",
                        type: "and",
                      }}
                    />
                  </div>

                  <div className="col-12 col-lg-6">
                    <IlceGeneliPartilerinOyDegisimiBar
                      city={city}
                      district={district}
                      title="Verilen Göçün Siyasi Duruma Etkisi"
                      type={"alinan-verilen-goc-siyaset-etkisi"}
                      filter={{
                        key: "ALT-KATEGORI-2",
                        value: "VERİLEN GÖÇÜN SİYASETE ETKİSİ (BİREY BAZLI)",
                        operator: "=",
                        type: "and",
                      }}
                    />
                  </div>

                  <div className="col-12">
                    <DynamicCard
                      item={{
                        title: "Siyasi Kimlik Dağılımı",
                      }}
                      fullScreen={true}
                      events={false}
                      chart={
                        <SiyasiKimlikDagilimi city={city} district={district} />
                      }
                    />
                  </div>

                  <div className="col-12">
                    <DynamicCard
                      item={{
                        title:
                          "GÜNDEN GÜNE 5 YILLIK GENEL SIYASI ANKET SONUÇLARI",
                      }}
                      height={1000}
                      fullScreen={true}
                      events={false}
                      chart={<GenelSiyasiAnketSonuclari />}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <div className="row g-3">
                  <div className="col-12">
                    <h4>{context?.t?.mahalle_analizi}</h4>
                    <ol className="d-inline-flex breadcrumb mb-0">
                      <li className="breadcrumb-item">{city}</li>
                      <li className="breadcrumb-item">{district}</li>
                    </ol>
                  </div>

                  {allNeighborhood.length === 0 ? (
                    <div className="col-12">
                      <div className="spinner-border text-theme"></div>
                    </div>
                  ) : (
                    <MahalleGeneliPartilerinOyDegisimi
                      city={city}
                      district={district}
                      allNeighborhood={allNeighborhood}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
